import { render, staticRenderFns } from "./BloodTypes.vue?vue&type=template&id=37e2c077&"
import script from "./BloodTypes.vue?vue&type=script&lang=js&"
export * from "./BloodTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports